import ScrollDepthTracking from 'marketing/utils/ScrollDepthTracking';
import RellaxElements from 'marketing/utils/RellaxElements';
import Accordion from './components/Accordion';
import Waypoint from 'waypoints/lib/noframework.waypoints';
import SlideCarousel from './components/slide-carousel';
import { once } from 'lodash';
import { trackLink, trackEvent } from '@99designs/common/utils/platform';
import ScrollToElement from './components/ScrollToElement';
import StickyBar from './components/StickyBar';

function trackAccordionClick(triggerElement, itemElement) {
    if (itemElement.hasAttribute('data-active')) {
        trackEvent('Clicked FAQ on How It Works page', {
            faq_section: itemElement.getAttribute('data-faq-section'),
            faq_question: itemElement.getAttribute('data-faq-question'),
        });
    }
}

// Track scroll position
document.addEventListener('DOMContentLoaded', () => {
    new ScrollDepthTracking('How It Works');
});

// initialise Accordions
document.addEventListener('DOMContentLoaded', () => {
    Accordion.create('[data-accordion]', trackAccordionClick);
});

// Activate rellax elements for parallax scrolling
document.addEventListener('DOMContentLoaded', () => {
    const rellaxElements = document.querySelectorAll('[data-rellax]');

    if (rellaxElements) {
        new RellaxElements(rellaxElements);
    }
});

// Initialise testimonial carousel
document.addEventListener('DOMContentLoaded', () => {
    SlideCarousel.create();
});

// Trigger communication-showcase animation steps
document.addEventListener('DOMContentLoaded', () => {
    const showcase = document.querySelector('[data-communication-showcase]');
    const section = document.querySelector('[data-section-id="collaborate"]');
    const nav = document.querySelector('[data-sticky-bar]');
    const orange = '#D87F00';

    new Waypoint({
        element: section,
        offset: '60%',
        handler: once(() => {
            setTimeout(() => {
                showcase.setAttribute('data-animation-step', 1);
            }, 1000);

            setTimeout(() => {
                showcase.setAttribute('data-animation-step', 2);
                section.style.color = orange;
                nav.style.color = orange;
            }, 4000);

            setTimeout(() => {
                showcase.setAttribute('data-animation-step', 3);
            }, 7000);
        }),
    });
});

// CTA click tracking
document.addEventListener('DOMContentLoaded', () => {
    const howItWorksCTA = document.querySelectorAll('[data-hiw-cta]');

    Array.from(howItWorksCTA).forEach(element => {
        trackLink(element, 'Clicked CTA on How It Works page', {
            cta_location: element.getAttribute('data-hiw-cta-location'),
        });
    });
});

// Sticky nav
document.addEventListener('DOMContentLoaded', () => {
    new StickyBar();
    createStickyNavWaypoints();
});

function createStickyNavWaypoints() {
    const briefElement = document.querySelector('[data-section-id="brief"]');
    new Waypoint({ element: briefElement, handler: () => updateNavColors(briefElement) });
    new Waypoint({
        element: briefElement,
        handler: () => updateNavColors(briefElement),
        offset: 'bottom-in-view',
    });

    const connectElement = document.querySelector('[data-section-id="connect"]');
    new Waypoint({
        element: connectElement,
        handler: () => updateNavColors(connectElement),
        offset: '20%',
    });
    new Waypoint({
        element: connectElement,
        handler: () => updateNavColors(connectElement),
        offset: 'bottom-in-view',
    });

    const collaborateElement = document.querySelector('[data-section-id="collaborate"]');
    new Waypoint({
        element: collaborateElement,
        handler: () => updateNavColors(collaborateElement),
        offset: '25%',
    });
}

function updateNavColors(element) {
    const sectionId = element.getAttribute('data-section-id');
    const nav = document.querySelector('[data-sticky-bar]');
    const navItem = document.querySelector(`[data-page-nav-item="${sectionId}"]`);

    navItem.setAttribute('data-active', true);
    nav.style.color = element.style.color;

    let navItemDataAttributes = [
        '[data-page-nav-item="brief"]',
        '[data-page-nav-item="connect"]',
        '[data-page-nav-item="collaborate"]',
    ];

    let index = navItemDataAttributes.indexOf(`[data-page-nav-item="${sectionId}"]`);
    navItemDataAttributes.splice(index, 1);
    navItemDataAttributes.forEach(function(dataAttribute) {
        document.querySelector(dataAttribute).removeAttribute('data-active');
        document.querySelector(dataAttribute).removeAttribute('style');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-scrollto]');

    for (const element of elements) {
        new ScrollToElement(element).handleClick();
    }
});



// WEBPACK FOOTER //
// ./js/marketing/howItWorks.jsx